import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { HomeHeader } from './components/HomeHeader';
import { HeroSection } from './components/HeroSection';
import { KeyFeatures } from './components/KeyFeatures';
import { AvailableTools } from './components/AvailableTools';
import { GettingStarted } from './components/GettingStarted';
import { ConnectionMethods } from './components/ConnectionMethods';
import { Footer } from './components/Footer';
import { initScrollHandlers } from './utils/scroll';
import { WidgetErrorBoundary } from '../components/WidgetErrorBoundary';
import '../index.css';

function HomePage() {
    useEffect(() => {
        const cleanup = initScrollHandlers();
        return cleanup;
    }, []);

    return (
        <div className="min-h-screen w-full bg-[#0F1419] text-[#F8FAFC]">
            <HomeHeader />

            <main id="main-content">
                <HeroSection />
                <KeyFeatures />
                <AvailableTools />
                <GettingStarted />
                <ConnectionMethods />
            </main>

            <Footer />

            {/* Back to Top Button */}
            <BackToTopButton />
        </div>
    );
}

function BackToTopButton() {
    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <button
            id="back-to-top"
            className="pointer-events-none fixed right-8 bottom-8 z-40 flex h-12 w-12 transform items-center justify-center rounded-full bg-gradient-to-br from-[#E81932] to-[#C41E3A] text-white opacity-0 shadow-xl shadow-[#E81932]/30 transition-all hover:scale-110 hover:shadow-[#E81932]/50 [.visible_&]:pointer-events-auto [.visible_&]:opacity-100"
            aria-label="Back to top"
            onClick={handleClick}
        >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
            </svg>
        </button>
    );
}

// Mount the app
const rootElement = document.getElementById('homepage-root');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
        <WidgetErrorBoundary>
            <HomePage />
        </WidgetErrorBoundary>
    );
}
